import { render } from "./BaseLayoutColumn.vue?vue&type=template&id=ac67ca14&scoped=true&ts=true"
import script from "./BaseLayoutColumn.vue?vue&type=script&lang=ts"
export * from "./BaseLayoutColumn.vue?vue&type=script&lang=ts"

import "./BaseLayoutColumn.vue?vue&type=style&index=0&id=ac67ca14&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac67ca14"]])

export default __exports__